import React from 'react';
import ReactDOM from 'react-dom';
import GuessTheCountryApp from './App';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <GuessTheCountryApp />
  </React.StrictMode>,
  document.getElementById('root')
);
